module.exports = __webpack_public_path__ + "static/media/iris_editor_metrics_sub.7eb1a1a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iris_editor_metrics_sub.png
// module id = 389
// module chunks = 16